import { createSlice, type PayloadAction } from "@reduxjs/toolkit/react";
import {
  CHAT_MAX_WIDTH,
  CHAT_MIN_WIDTH,
  ChatMessageSource,
  type ChatMessageSource as ChatMessageSourceValue,
} from "../utilities/chat";
import { loadChat } from "./persist";

export type InitialQuestion = {
  text: string;
  source: ChatMessageSourceValue;
};

export type ChatState = {
  isOpen: boolean;
  initialQuestion: InitialQuestion | null;
  width: number;
};

const initialState: ChatState = {
  isOpen: false,
  initialQuestion: null,
  ...loadChat(),
};

export const chat = createSlice({
  name: "chat",
  initialState,
  reducers: {
    open: (state): ChatState => ({ ...state, isOpen: true }),
    close: (state): ChatState => ({ ...state, isOpen: false }),
    openWithQuestion: (state, action: PayloadAction<string>): ChatState => ({
      ...state,
      isOpen: true,
      initialQuestion: {
        text: action.payload,
        source: ChatMessageSource.Typed,
      },
    }),
    openWithSuggestion: (state, action: PayloadAction<string>): ChatState => ({
      ...state,
      isOpen: true,
      initialQuestion: {
        text: action.payload,
        source: ChatMessageSource.Suggestion,
      },
    }),
    clearInitialQuestion: (state): ChatState => ({
      ...state,
      initialQuestion: null,
    }),
    setWidth: (state, action: PayloadAction<number>): ChatState => ({
      ...state,
      width: Math.min(Math.max(action.payload, CHAT_MIN_WIDTH), CHAT_MAX_WIDTH),
    }),
  },
});
